import { Snackbar, Alert } from '@mui/material';

const CustomSnackbar = ({ open, message, severity, onClose }) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={onClose}
            sx={{
                top: {
                    xs: 'env(safe-area-inset-top, 24px)',
                    sm: '24px'
                }
            }}
        >
            <Alert
                severity={severity}
                sx={{
                    width: "100%",
                    backgroundColor: "white",
                    boxShadow: 3,
                    fontWeight: 600,
                    border: "1px solid #000",
                    borderColor: "brand.main",
                }}
                onClose={onClose}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar; 